export default __webpack_public_path__ + "static/psgCard7-e4e41fcfda27eb48670a1761b87cbe41.webp";